import { Link } from "react-router-dom";
import type { StepAvailabilityProps } from "../../../core/types/tsx/components/wizard/provider-registration/StepAvailability.types";
import { AvailabilityScheduleEditor } from "../../common/AvailabilityScheduleEditor";

export function StepAvailability({
	availability,
	setAvailability,
	errors,
	clearError,
	accepted,
	setAccepted,
}: StepAvailabilityProps) {
	return (
		<>
			<AvailabilityScheduleEditor
				availability={availability}
				onToggleDay={(day) => {
					clearError("availability");
					setAvailability((prev) =>
						prev.map((slot) =>
							slot.day === day ? { ...slot, enabled: !slot.enabled } : slot,
						),
					);
				}}
				onChangeSchedule={(day, field, value) => {
					clearError("availability");
					setAvailability((prev) =>
						prev.map((slot) =>
							slot.day === day ? { ...slot, [field]: value } : slot,
						),
					);
				}}
			/>

			{errors.availability ? (
				<p className='mt-1 text-xs text-red-600'>{errors.availability}</p>
			) : null}

			<div className='rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800'>
				<span className='font-semibold'>Nota:</span> Estos horarios se mostrarán
				en tu perfil público y podrás modificarlos más tarde desde tu
				configuración.
			</div>

			<label className='flex cursor-pointer items-center gap-2 text-sm text-slate-600'>
				<input
					type='checkbox'
					checked={accepted}
					onChange={(e) => {
						clearError("accepted");
						setAccepted(e.target.checked);
					}}
					className='cursor-pointer h-4 w-4 rounded border-slate-300 text-primary focus:ring-secondary'
				/>
				<span>
					Acepto las{" "}
					<Link
						to='/politicas'
						className='text-primary hover:text-primary-hover'
					>
						políticas
					</Link>{" "}
					y los{" "}
					<Link
						to='/terminos-condiciones'
						className='text-primary hover:text-primary-hover'
					>
						términos
					</Link>
				</span>
			</label>
			{errors.accepted ? (
				<p className='mt-1 text-xs text-red-600'>{errors.accepted}</p>
			) : null}
		</>
	);
}
